// extracted by mini-css-extract-plugin
module.exports = {"container":"IngressWithCta_container__OV_SI","buttonContainer":"IngressWithCta_buttonContainer___CpmQ"};